// hooks/useCidades.ts
import { useFetch } from "./useFetch";
import { cidadeService } from "../services/cidadeService";
import { Cidade } from "../interfaces/Cidade";

export const useCidades = (estadoId?: number) => {
  const { isLoading, data, error } = useFetch<Cidade[]>(
    !!estadoId, // só busca se tiver estadoId
    cidadeService,
    [estadoId],
    estadoId
  );

  return { isLoading, data, error };
};
